import React, { useState, useEffect } from 'react';


import {
  ContainerPopular,
  ContainerMost,
  CardImagePopular,
  CardImageMost,
  CardTitle,
  CardCategory,
} from './styles';

export default function CardService({
  service, openForm, variant, className,
}) {
  const [serviceImageName, setServiceImageName] = useState('');

  useEffect(() => {
    setServiceImageName(
      service.text
        .toLowerCase()
        .replace(/ /g, '-')
        .replace(/´/g, '')
        .replace(/\(|\)/g, '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, ''),
    );
  }, [service]);

  const Container = variant === 'popular' ? ContainerPopular : ContainerMost;
  const CardImage = variant === 'popular' ? CardImagePopular : CardImageMost;

  return (
    <Container
      onClick={openForm}
      className={className}
    >
      <CardImage
        url={`https://www.triider.com.br/img/photos/novas/${serviceImageName}.jpg`}
        imgDefault="../categories/outros-serviços.svg"
        alt={`Imagem de ${service.text}`} />
      <CardTitle>{service.text}</CardTitle>
      <CardCategory>{service.service_group}</CardCategory>
    </Container>
  );
}
